import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '../../form/components/button/button.component';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent],
})
export class ConfirmModalComponent {
  text!: string;
  title!: string;
  cancelText!: string;
  confirmText!: string;
  confirmColor = 'primary';
  cancelColor = 'link';
  confirmSecondaryText?: string;
  confirmSecondaryColor = 'primary';
  constructor(public activeModal: NgbActiveModal) {}
}


